import { createMandatoryContext } from 'contexts/utils';
import { EventOrTimeslot } from 'types/Event';

interface DayEventContextProps {
  dayEventOrTimeslot: EventOrTimeslot;
}

const userContext = createMandatoryContext<DayEventContextProps>(),
  [useDayEventContext, DayEventContextProvider] = userContext;

export { useDayEventContext, DayEventContextProvider };
